// extracted by mini-css-extract-plugin
module.exports = {"banner":"ClashingReservationWarning_banner__1U_LD","totalNumber":"ClashingReservationWarning_totalNumber__2aMiJ"};